import { createSelector } from 'reselect';

const selectDomain = () => (state) => state.get('leaveDialogue');

const makeSelectLeaveDialogue = () =>
  createSelector(selectDomain(), (substate) => substate);

export { makeSelectLeaveDialogue };
